export const formattedBigNumbers = (number) => {
  if (+number >= 1000000) {
    return (+number / 1000000).toFixed() + "M";
  } else if (+number >= 1000) {
    return (+number / 1000).toFixed() + "K";
  } else {
    return number.toFixed();
  }
};
